import PropTypes from "prop-types";
import React from "react";
import GenericQuizExecutor from "../../GenericQuiz/executor.js";
import WordQuestion from "./word-question.js";

function Executor(props) {
  return (
    <GenericQuizExecutor {...props} activityEndpoint={"dictation"}>
      {(props) => <WordQuestion {...props} />}
    </GenericQuizExecutor>
  );
}
Executor.propTypes = {
  params: PropTypes.object,
  onEnd: PropTypes.func,
};

export default Executor;
